import React, { FC, ReactNode, useMemo } from 'react';
import { ConfluenceExperimentsContext } from '@post-office/growth-common/confluence-experiments-context';

import { EmojiResource } from '@atlaskit/emoji/resource';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { getEmojiProvider } from '@confluence/fabric-providers/entry-points/EmojiProvider';

import { getPageDataFromUrl } from './hooks/getPageDataFromUrl';
import { usePageRecommendationData } from './hooks/usePageRecommendationData';
import { useInlineReactionsData } from './hooks/useInlineReactionsData';

export const ConfluenceExperimentsProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const { userId, cloudId } = useSessionData();

	const experimentsContextValue = useMemo(() => {
		return {
			usePageRecommendationData,
			useInlineReactionsData,
			getPageDataFromUrl,
			emojiProvider: getEmojiProvider(EmojiResource, {
				userId,
				cloudId,
			}),
		};
	}, [userId, cloudId]);

	return (
		<ConfluenceExperimentsContext.Provider value={experimentsContextValue}>
			{children}
		</ConfluenceExperimentsContext.Provider>
	);
};
